import React, { memo } from 'react';
import { Channel } from '@sendbird/uikit-react';

interface ChannelWrapperProps {
  channelUrl: string;
  onChatHeaderActionClick?: () => void;
  showSearchIcon?: boolean;
  onSearchClick?: () => void;
  onBeforeSendUserMessage?: (text: string, quotedMessage?: any) => any;
  onBeforeSendFileMessage?: (file: File, quotedMessage?: any) => any;
  renderChannelHeader?: () => React.ReactNode;
  renderUserProfile?: () => React.ReactNode;
}

// Wrapper component to isolate Sendbird UIKit hook violations
const ChannelWrapper: React.FC<ChannelWrapperProps> = memo((props) => {
  // Suppress console warnings for this specific component
  React.useEffect(() => {
    const originalError = console.error;
    const originalWarn = console.warn;
    
    const suppressSendbirdWarnings = (message: any, ...args: any[]) => {
      const messageStr = String(message);
      
      // Suppress specific Sendbird hook warnings
      if (
        messageStr.includes('Do not call Hooks inside useEffect') ||
        messageStr.includes('React has detected a change in the order of Hooks') ||
        messageStr.includes('ChannelProvider')
      ) {
        return; // Suppress the warning
      }
      
      // Allow other warnings/errors to pass through
      originalError(message, ...args);
    };
    
    const suppressSendbirdWarns = (message: any, ...args: any[]) => {
      const messageStr = String(message);
      
      // Suppress specific Sendbird hook warnings
      if (
        messageStr.includes('Do not call Hooks inside useEffect') ||
        messageStr.includes('React has detected a change in the order of Hooks') ||
        messageStr.includes('ChannelProvider')
      ) {
        return; // Suppress the warning
      }
      
      // Allow other warnings to pass through
      originalWarn(message, ...args);
    };
    
    console.error = suppressSendbirdWarnings;
    console.warn = suppressSendbirdWarns;
    
    return () => {
      console.error = originalError;
      console.warn = originalWarn;
    };
  }, []);

  return <Channel {...props} />;
});

ChannelWrapper.displayName = 'ChannelWrapper';

export default ChannelWrapper;
